import script from "./BackOfficeView.vue?vue&type=script&setup=true&lang=js"
export * from "./BackOfficeView.vue?vue&type=script&setup=true&lang=js"

import "./BackOfficeView.vue?vue&type=style&index=0&id=91d93402&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91d93402"]])

export default __exports__